<!-- 定位接口设置 -->
<template>
  <div class="campus-announcement">
    定位接口设置
  </div>
</template>

<script>
export default {
  components: {

  },
  data() {
      return {
      };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
.campus-announcement {
  height: 100%;
  background-color: #fff;
}
</style>
